import { render } from "./github-stats.vue?vue&type=template&id=29213c3e&scoped=true"
import script from "./github-stats.vue?vue&type=script&lang=js"
export * from "./github-stats.vue?vue&type=script&lang=js"

import "./github-stats.vue?vue&type=style&index=0&id=29213c3e&scoped=true&lang=scss"

import exportComponent from "/home/mark/Dev/www/Portfolio/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29213c3e"]])

export default __exports__